export const sideBar = () => {
  return {
    work_orders: 'Órdenes de Trabajo',
    invoices: 'Facturas',
    company_profile: 'Perfil de la Compañía',
    exit_masquerade: 'Salir de la Máscara'
  }
}
